import React, {Component, Fragment} from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import {Switch, Route} from 'react-router-dom';
import {StationManagerAlertDashboard} from '../components';
import PageNotFound from "../../../common/components/PageNotFound";

class StationManagerAlert extends Component {
	render() {
		const {pageTitle, match} = this.props;

		return (
			<Fragment>
				<Helmet title={pageTitle}/>
				<Switch>
					<Route exact path={match.url + "/"} component={StationManagerAlertDashboard}/>
					<Route component={PageNotFound}/>
				</Switch>
			</Fragment>
		);
	}
}

StationManagerAlert.defaultProps = {
	pageTitle: 'Alerts'
};

StationManagerAlert.propTypes = {
	pageTitle: PropTypes.string
};

export default StationManagerAlert;
